import { render } from "./AchievementPopup.vue?vue&type=template&id=548fd35c&scoped=true"
import script from "./AchievementPopup.vue?vue&type=script&lang=js"
export * from "./AchievementPopup.vue?vue&type=script&lang=js"

import "./AchievementPopup.vue?vue&type=style&index=0&id=548fd35c&scoped=true&lang=css"

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548fd35c"]])

export default __exports__